import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_EXPENSE_URL || 'https://your-api-gateway-url.amazonaws.com/prod';

// Helper function to get current user and create API instance
const getApiInstance = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = user?.token;
  
  return {
    api: axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': token
      },
    }),
    user
  };
};

export const categoryService = {
  async getCategories() {
    const { api, user } = getApiInstance();
    const data = { cmd: "getCategories", familyId: user.familyId };
    const response = await api.post('/expenses', data);
    return JSON.parse(response.data.body);
  },

  async getCategoriesFlat() {
    const { api, user } = getApiInstance();
    const data = { cmd: "getCategoriesFlat", familyId: user.familyId, user: user };
    const response = await api.post('/expenses', data);
    return JSON.parse(response.data.body);
  },

  async getSubcategories(parentId) {
    const { api, user } = getApiInstance();
    const data = { cmd: "getSubcategories", pathParameters: { parentId }, user: user };
    const response = await api.post('/expenses', data);
    return JSON.parse(response.data.body);
  },

  async createCategory(categoryData) {
    const { api, user } = getApiInstance();
    let data = { cmd: "createCategory", data: categoryData};
    data.user = user;
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async updateCategory(categoryId, categoryData) {
    const { api, user } = getApiInstance();
    categoryData.id = categoryId;
    const data = { cmd: "updateCategory", data: categoryData, user: user}
    const response = await api.post(`/expenses`, data);
    return response.data;
  },

  async deleteCategory(categoryId) {
    const { api, user } = getApiInstance();
    const data = { cmd: "deleteCategory", data: { categoryId }, user: user };
    const response = await api.post('/expenses', data);
    return response.data;
  },

  async initializeDefaultCategories() {
    const { api, user } = getApiInstance();
    const data = { cmd: "initializeDefaultCategories", data: { user: user } };
    const response = await api.post('/expenses', data);
    return JSON.parse(response.data.body);
  }
};